const topicsData = [
  { name: '暑期档', hot: true },
  { name: '高分华语', hot: true },
  { name: '悬疑推理', hot: false },
  { name: '科幻大片', hot: true },
  { name: '都市情感', hot: false },
  { name: '搞笑综艺', hot: false },
  { name: '经典港片', hot: false },
  { name: '动漫新番', hot: true },
  { name: '纪录片', hot: false },
  { name: '古装权谋', hot: false },
  { name: '院线新片', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50 mb-3">热门话题</h2>
          <p className="text-foreground-400 text-sm">最受关注的内容标签，发现热门讨论方向</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 max-w-[900px] mx-auto">
          {topicsData.map((topic, i) => (
            <a
              key={i}
              href="#ranking"
              className={`inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer border ${
                topic.hot
                  ? 'bg-accent-500/10 text-accent-400 border-accent-500/25 hover:bg-accent-500/20'
                  : 'bg-background-200 text-foreground-300 border-background-300/40 hover:border-foreground-500/30 hover:text-foreground-100'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-xs"></i>}
              {topic.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}